import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const LoginContent = ({ content, onChange }) => {
  const handleEmailChange = email => {
    onChange({ email });
  };

  const handlePasswordChange = password => {
    onChange({ password });
  };

  return (
    <Flex center fat="true" xSpace>
      <Span>using</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Email"
          placeholder="Email"
          value={content.email}
          onChange={handleEmailChange}
        />
      </Flex>
      <Span>and</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Password"
          placeholder="Password"
          value={content.password}
          onChange={handlePasswordChange}
        />
      </Flex>
    </Flex>
  );
};

LoginContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired
  }).isRequired
};

export default LoginContent;
